export default __webpack_public_path__ + "static/media/national-rail.e406b72e.jpeg";